import { useEffect, useState } from 'react';

export default function EditarBoletim() {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/boletim.config.json')
      .then(res => res.json())
      .then(data => setConfig(data))
      .finally(() => setLoading(false));
  }, []);

  function atualizarPrompt(e) {
    setConfig({
      ...config,
      prompt: {
        ...config.prompt,
        texto: e.target.value
      }
    });
  }

  function downloadJSON() {
    const blob = new Blob(
      [JSON.stringify(config, null, 2)],
      { type: 'application/json' }
    );

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'boletim.config.json';
    link.click();
  }

  if (loading) return <p>Carregando...</p>;
  if (!config) return <p>Erro ao carregar config</p>;

  return (
    <div style={{ padding: 20 }}>
      <h2>Editar Prompt do Boletim</h2>

      <textarea
        value={config.prompt.texto}
        onChange={atualizarPrompt}
        rows={16}
        style={{ width: '100%' }}
      />

      <p>
        Caracteres: {config.prompt.texto.length}
      </p>

      <button onClick={downloadJSON}>
        Baixar JSON Atualizado
      </button>
    </div>
  );
}
